import { render, staticRenderFns } from "./homeClassify.vue?vue&type=template&id=2738651a&scoped=true"
import script from "./homeClassify.vue?vue&type=script&lang=js"
export * from "./homeClassify.vue?vue&type=script&lang=js"
import style0 from "./homeClassify.vue?vue&type=style&index=0&id=2738651a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738651a",
  null
  
)

export default component.exports